import React from "react";
import { useChatState } from "../../state/ChatState";
import PhoneIcon from "../../helpers/PhoneIcon";
import ChatIcon from "../../helpers/ChatIcon";
import TypewriterHeader from "../TypewriterHeader";

export const ChooseAgent = ({
	selectedAgent,
}: {
	selectedAgent: (
		langIndex: number,
		agentId: string,
		promptId?: string | undefined,
	) => void;
}) => {
	const chatState = useChatState();
	const homeTitles =
		chatState.baseConfig?.HOME_TITLES?.split("|").filter(Boolean) ?? [];
	const buttons = chatState.baseConfig?.BUTTONS?.split("|") ?? [];
	const isVoice = chatState.baseConfig?.IS_VOICE_CHAT === "true";

	const selectedLanguage = (langIndex: number) => {
		const agentId = String(
			chatState.baseConfig?.AGENT_IDS.split("|")?.[langIndex],
		);
		const promptId = chatState.baseConfig?.PROMPT_ID;
		selectedAgent(langIndex, agentId, promptId);
	};

	return (
		<div className="flex flex-col w-full items-center justify-center backdrop-blur-sm">
			<div
				data-id="title_and_buttons"
				className="flex flex-col items-center w-full "
			>
				<TypewriterHeader
					lines={homeTitles}
					className="text-2xl md:text-4xl mt-2 md:mt-4 mb-10 md:mb-14"
				/>

				<div className="flex flex-col md:flex-row md:flex-wrap md:justify-center w-full md:w-auto gap-3 md:gap-4">
					{buttons.map((button, index) => (
						<button
							key={index}
							onClick={() => selectedLanguage(index)}
							className="hover:bg-opacity-80 font-medium py-3 px-6 rounded-xl text-sm md:text-base flex flex-row items-center justify-center gap-2 w-full md:w-auto md:whitespace-nowrap"
							id="primary_button"
						>
							{isVoice ? (
								<PhoneIcon width={19} height={19} color="currentColor" />
							) : (
								<ChatIcon width={19} height={19} color="currentColor" />
							)}
							{button}
						</button>
					))}
				</div>
			</div>
		</div>
	);
};
